import { chakra, IconButton } from "@chakra-ui/react"

export const NavigationButton = chakra(IconButton, {
  baseStyle: {
    position: "absolute",
    borderRadius: "full",
    bg: "white",
    zIndex: 5,
    cursor: "pointer",
    _disabled: {
      display: "none",
    },
  },
})
